namespace e5{
    export interface IQuadValue {
        p1: Point3d;
        p2: Point3d;
        p3: Point3d;
        p4: Point3d;
    }
    
    export class Quad implements IQuadValue {
        public points: Point3d[] = [];
        constructor(
            public p1: Point3d = new Point3d(),
            public p2: Point3d = new Point3d(),
            public p3: Point3d = new Point3d(),
            public p4: Point3d = new Point3d()
        ) {
            this.points = [this.p1, this.p2, this.p3, this.p4];
        }
    
        public clone(): Quad {
            return new Quad(
                this.p1.clone(),
                this.p2.clone(),
                this.p3.clone(),
                this.p4.clone());
        }
    
        public setRect(x: number, y: number, width: number, height: number): Quad {
            this.p1.x = x;
            this.p1.y = y;
            this.p2.x = x + width;
            this.p2.y = y;
            this.p3.x = x + width;
            this.p3.y = y + height;
            this.p4.x = x;
            this.p4.y = y + height;
            return this;
        }
    
        public setData(
            data: IPoint3dValue[]): Quad {
            this.p1.copyFrom(data[0]);
            this.p2.copyFrom(data[1]);
            this.p3.copyFrom(data[2]);
            this.p4.copyFrom(data[3]);
            return this;
        }
    
        public setTo(
            p1: IPoint3dValue,
            p2: IPoint3dValue,
            p3: IPoint3dValue,
            p4: IPoint3dValue): Quad {
            this.p1.copyFrom(p1);
            this.p2.copyFrom(p2);
            this.p3.copyFrom(p3);
            this.p4.copyFrom(p4);
            return this;
        }
    
        public copyFrom(value: IQuadValue): Quad {
            return this.setTo(value.p1, value.p2, value.p3, value.p4);
        }
    
        public dispose(): void {
        }
    }
}